import apiClient from "./apiClient";
import { supabase } from "./supabaseClient";

export async function getSubscriptionPlans() {
  const { data } = await apiClient.post("/get_subscription_plans");
  return data as {
    products: Array<{
      id: string;
      name: string;
      description: string | null;
      created: string;
      prices: Array<{
        id: string;
        currency: string;
        unit_amount: number;
        formatted_amount: string;
        recurring: {
          interval: string;
          interval_count: number;
          meter: string | null;
          trial_period_days: number | null;
          usage_type: string;
        };
        interval: string;
      }>;
    }>;
  };
}

export async function createCheckoutSession(
  priceId: string,
  successUrl: string,
  cancelUrl: string,
  isGuestUpgrade?: boolean,
  guestUserId?: string
) {
  const requestData: any = {
    price_id: priceId,
    success_url: successUrl,
    cancel_url: cancelUrl,
  };
  console.log("requestDatarequestData:", requestData);

  // Add guest upgrade metadata if this is a guest user upgrading
  if (isGuestUpgrade && guestUserId) {
    requestData.metadata = {
      is_guest_upgrade: 'true',
      guest_user_id: guestUserId
    };
    console.log("🔍 Sending guest upgrade metadata:", requestData.metadata);
  } else {
    console.log("🔍 No guest upgrade metadata (isGuestUpgrade:", isGuestUpgrade, "guestUserId:", guestUserId, ")");
  }

  console.log("📤 Sending checkout request:", requestData);
  console.log("📤 Request data keys:", Object.keys(requestData));
  console.log("📤 Metadata being sent:", requestData.metadata);
  // Try to include the current user's email as a fallback so stripe prefill can match
  try {
    const { data: sessionData } = await supabase.auth.getSession();
    const tokenUserEmail = sessionData?.session?.user?.email;
    if (tokenUserEmail) {
      requestData.user_email = tokenUserEmail;
    }
  } catch (err) {
    // ignore
  }

  const { data } = await apiClient.post("/create-checkout-session", requestData);
  return data as { checkout_url: string };
}
export async function checkSession(sessionId: string) {
  const { data } = await apiClient.post("/check_session", {
    session_id: sessionId,
  });
  return data as {
    payment_status: string;
    customer_email?: string;
    is_existing_user?: boolean;
    is_upgrade?: boolean;
  };
}
